// import router from "@/router";

export default {
  namespaced: true,
  state() {
    return {
      path: {
        casino: "casino/play/",
        allGames: "static/theear/gamesSkinProvider?",
        allCertifications: "static/theear/gamesCertification",
        // https://stage-api.theearplatform.com/v1/static/theear/gamesSkinProvider?provider_id=207&skin_ref_id=4003
        games: "casino/games?page=",
        games_detail: "casino/providers/207/games/",
        games_detail_v2: "casino/providers/207/games/",
        gameSearched: "casino/games?name=",
        sections: "casino/sections",
        game_section: "casino/games?&section_id=",
        providers: "casino/providers",
        filterdProviders: "casino/games?",
        filterdGameSidebar: "casino/games?",
        gamePageStart: "static/casinoGames/",
        skinBanner: "cms/banners"
      },
      //    const res = await this.$store.dispatch("promotion/callBanners", {
      //   playerID: null,
      //   tag: "home",
      // });
      howManyGamesPerPage: 4,
      games: [],
      currentGamePath: null,
      currentGameDescription: "",
      currentGames: [],
      //Skin
      allSkinGames: null,
      allSkinProviders: null,
      isAllSkinGamesLoading: true,
      isAllProvidersLoading: true,
      isLoadingCardGames: false,
      allSkinSections: null,
      game_detail: {},
    };
  },
  getters: {
    currentGamePath(state) {
      return state.currentGamePath;
    },
    currentGameDescription(state) {
      return state.currentGameDescription;
    },
    endpoint(_, _1, _2, rootGetters) {
      return rootGetters["api/endpoint"];
    },
    axios(_, _1, _2, rootGetters) {
      return rootGetters["api/axios"];
    },
    auth(_, _1, _2, rootGetters) {
      return rootGetters["api/auth"];
    },
    isLoadingCardGames(state) {
      return state.isLoadingCardGames;
    },
    currentPage(state) {
      return state.currentPage;
    },
    last_page(state) {
      return state.last_page;
    },
    games(state) {
      return state.games;
    },
    gamesTopWin(state) {
      return state.gamesTopWin;
    },
    gamesPopularSections(state) {
      return state.gamesPopularSections;
    },
    gamesLiveCasino(state) {
      return state.gamesLiveCasino;
    },
    currentProvider(state) {
      return state.currentProvider;
    },
    searchResults(state) {
      return state.searchResults;
    },
    // SELECTED GAMES DEPENDENT ON PAGE
    selectedSection(state) {
      return state.selectedSection;
    },
    sectionsAndGamesInThisPage(state) {
      return state.sectionsAndGamesInThisPage;
    },
    gamesInThisSection(state) {
      return state.gamesInThisSection;
    },
    allSkinProviders(state) {
      return state.allSkinProviders;
    },
    isAllProvidersLoading(state) {
      return state.isAllProvidersLoading;
    },

    // ONLY FOR LAUNCH GAME PAGE
    allSkinSections(state) {
      return state.allSkinSections;
    },
    isAllSkinGamesLoading(state) {
      return state.isAllSkinGamesLoading;
    },
    game_detail(state) {
      return state.game_detail;
    },
  },
  mutations: {
    setCurrentProvider(state, slug) {
      state.currentProvider = slug;
    },
    setIsLoadingCardGames(state, value) {
      state.isLoadingCardGames = value;
    },
    setGamesToDisplay(state, payload) {
      if (state.wordToSearch !== null) {
        state.searchResults = payload.data || [];
      }
      if (payload.data != null) {
        state.games = payload.data;
      } else if (!state.isChangePage) {
        state.games = payload;
      }
    },
    setGamesDetail(state, payload) {
      state.currentGameDescription = payload.data;
    },
    setSkinProviders(state, payload) {
      state.allSkinProviders = payload.data;
    },
    saveSkinSections(state, payload) {
      state.allSkinSections = payload;
    },
    clearFilter(state, payload) {
      state.games = payload;
    },

    setLaunchGames(state, payload) {
      state.game_detail = payload;
      state.allSkinGames_loaded = true;
      state.isAllSkinGamesLoading = false;
    },
    launchGame(state, payload) {
      state.currentGamePath = payload.responseData;
      state.isAllSkinGamesLoading = false;
    },
  },
  actions: {
    async callEarGames({ getters, state, commit }) {
      commit("setIsLoadingCardGames", true);
      const responseData = await getters.axios
        .get(
          getters.endpoint +
          state.path.allGames +
          "provider_id=207&is_branded=0&skin_ref_id=4003",
          getters.auth
        )
        .then((response) => response.data)
        .catch((err) => err);
      commit("setIsLoadingCardGames", false);
      commit("setGamesToDisplay", responseData);
    },
    async callEarCertification({ getters, state }) {

      const responseData = await getters.axios
        .get(
          getters.endpoint +
          state.path.allCertifications
          ,
          getters.auth
        )
        .then((response) => response.data)
        .catch((err) => err);
      return responseData
    },
    async callEarCertificationByGame({ getters, state }, gameId) {

      const responseData = await getters.axios
        .get(
          getters.endpoint +
          state.path.allCertifications + '?game=' + gameId
          ,
          getters.auth
        )
        .then((response) => response.data)
        .catch((err) => err);
      return responseData
    },
    async fetchBanners({ getters, state }) {
      const responseData = await getters.axios
        .get(
          getters.endpoint +
          state.path.skinBanner +
          "",
          getters.auth
        )
        .then((response) => response.data)
        .catch((err) => err);
      return responseData.data;
    },
    async callGamesDetail({ getters, state, commit }, { id, lang }) {
      const responseData = await getters.axios
        .get(
          getters.endpoint +
          state.path.games_detail_v2 +
          id +
          "?language=" +
          lang,
          getters.auth
        )
        .then((response) => response.data)
        .catch((err) => {
          console.error(err);
          window.location.href = "/404/NotFound";
        });
      commit("setGamesDetail", responseData);
    },
    async play_demo(
      { state, getters, commit },
      { game_id, provider_slug, currency, language }
    ) {
      let body = {
        is_demo: "true",
        game_id: game_id,
        provider_id: "207",
        user_language: language,
        user_currency: currency,
      };

      const responseData = await getters.axios
        .post(
          getters.endpoint + state.path.casino + provider_slug,
          body,
          getters.auth
        )
        .then((response) => response.data.data.play_for_fun)
        .catch((err) => err);
      commit("launchGame", { responseData });
    },
  },
};
